import style from "./style.module.scss";
import { useState, useRef, useEffect, useMemo } from "react";

import UplistItem from "./UplistItem";

import { storage } from "Utils/firebase";


function ImageUploader({ allowEntry, setAllowEntry, completed, retrySave, uploadFolder }) {
    const [upFiles, setUpFiles] = useState([]);
    const [uploadStatuses, setUploadStatuses] = useState([]);

    // console.log("To Upload To " + uploadFolder);

    // useEffect(
    //     async () => {
    //         console.log("getting reference...");
    //         var toclear = storage.ref("uploadto/621067");
    //         console.log("deleting..", uploadFolder, "-->", await toclear.getMetadata());
    //         try {
    //             // await toclear.delete();
    //         } catch (e) { console.log("UNABLE TO DELETE", e) }
    //     },[])

    const fileInput = useRef({});


    useEffect(() => {
        if (!allowEntry) {
            uploadFiles();
        } else {
            setUploadStatuses([])
            setUpFiles([])
        }
    }, [allowEntry])

    useEffect(() => {
        if (checkCompleted()) {
            fileInput.current.value = "";
            completed();
        };
    }, [retrySave])

    function dropped(e) {
        if (!allowEntry) return;

        addFiles(e.dataTransfer.files)
        e.preventDefault();
    }

    function addFiles(files) {
        var ids = upFiles.map((file) => {
            return `${file.name}${file.size}`
        });

        var news = [...files].filter((file) => { return (ids.indexOf(`${file.name}${file.size}`) < 0) });
        news = news.filter(file => (new RegExp("(\\.jpg|\\.jpeg|\\.png|\\.gif)$").test(file.name)));

        setUpFiles([...upFiles, ...news]);
        setUploadStatuses([...uploadStatuses, ...news.map(file => { return { state: 0, progress: 0 } })])
    }

    function removeFile(toRemove) {
        setUpFiles(upFiles.filter((file) => { return `${file.name}${file.size}` != `${toRemove.name}${toRemove.size}` }))
    }


    async function uploadFiles() {

        //clear folder before uploading files
        // if (uploadStatuses.filter(status => (status.state > 0)).length == 0) {
        //     var toclear = storage.ref(uploadFolder)
        //     try {
        //         await toclear.delete();
        //     } catch (e) { console.log("UNABLE TO DELETE", e) }
        // }

        if (upFiles.length == 0) {
            window.alert("You need to add files to upload")
            setAllowEntry(true);
            return;
        }

        // sfx = `/${Math.random()*10000000}`.substr(0, 6);

        upFiles.forEach((file, i) => {
            uploadFile(i);
        });

        // var newUploadStatuses = [...uploadStatuses];
        // newUploadStatuses[0] = {state:1, progress:10};
        // newUploadStatuses[2] = {state:2, progress:10};
        // setUploadStatuses(newUploadStatuses)
    }

    function uploadFile(i) {
        if ((uploadStatuses[i].state == 1) || (uploadStatuses[i].state == 2)) return;

        var upTar = storage.ref(uploadFolder + "/" + upFiles[i].name);

        var file = upFiles[i];
        uploadStatuses[i].state = 1;

        var upTask = upTar.put(file);
        upTask.on("state_changed", (snapshot) => {
            var progress = Math.floor((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
            changeStatus(i, { progress })
        }, (error) => {
            console.log("UploadError", error);
        }, (snapshot) => {
            // console.log("Upload Done");
            changeStatus(i, { state: 2 })
        });
    }

    function changeStatus(index, newStatus) {
        var newUploadStatuses = [...uploadStatuses];
        var curStatus = newUploadStatuses[index];
        curStatus.state = (newStatus.state == undefined) ? curStatus.state : newStatus.state;
        curStatus.progress = (newStatus.progress == undefined) ? curStatus.progress : newStatus.progress;

        newUploadStatuses[index] = curStatus;
        setUploadStatuses(newUploadStatuses);

        var chk = checkCompleted(newUploadStatuses);
        if (chk) completed();
        // if (newStatus.state == 2){
        //     console.log("Completed", chk);
        // }
    }

    function checkCompleted(chk) {
        var tocheck = chk ? chk : uploadStatuses;

        if (tocheck.length == 0) return false;
        return tocheck.filter(stat => (stat.state == 2)).length == tocheck.length;
    }

    return (
        <div className={style.ImageUploader}>

            <div className={style.uplist_cnt} onDrop={dropped} onDragOver={(e) => { e.preventDefault(); e.dataTransfer.dropEffect = "copy" }}>
                {(upFiles.length == 0) ?
                    <div className={style.drophere_cnt}>
                        <div className={style.drophere}>
                            Drop files here
                        </div>
                    </div>
                    :
                    <div className={style.uplist}>
                        {upFiles.map((file, i) => {
                            return <UplistItem key={`${file.name}${file.size}`} file={file} removeFile={removeFile} uploadStatus={allowEntry ? { state: -1, progress: 0 } : uploadStatuses[i]} retry={uploadFiles} />
                        })}
                    </div>
                }
            </div>

            <div className={style.upld_btn_cnt_cnt}>
                <div className={style.upld_btn_cnt}>
                    <button className="btn btn-info" type="button" onClick={e => fileInput.current.click()} disabled={!allowEntry}>Add Pictures</button>
                    <input type="file" hidden multiple ref={fileInput} accept="image/x-png, image/jpeg, image/gif" onChange={e => addFiles([...e.target.files])} />

                    <button className="btn btn-danger" onClick={() => { setUpFiles([]); fileInput.current.value = "" }} type="button" disabled={!allowEntry}>Clear</button>
                </div>
            </div>
        </div>
    );
}

export default ImageUploader;